import Axios from 'axios'

export default {
  mpesa_request (context, data) {
    Axios.post('http://localhost:9000/checkout', data).then(function () {
    }).catch(function (error) {
      // console.log(error.data)
    })
  }
}
